
const minifyGraphQLQuery = (query: string) => {
    return [" ", ":", "{", "}", "\\[", "]", "\\(", "\\)"].reduce(
        (prev, curr) => prev.replace(new RegExp(`\\s*${curr}\\s*`, "g"), curr.replace(/\\/g, "")), query);
}

export const createGetWishlistsByAsinQuery = (asin: string) => {
    const query =
    `
    query kqvGetWishlistsByAsin
    {
        getWishlistsByAsin(
            input : {
                asin: "${asin}"
            }
        ) {
            name
            wishlistNodeId
            isDefault
            visibility
        }
    }
    `;
    return minifyGraphQLQuery(query);
}

export const createRemoveFromWishlistsQuery = (asin: string, wishlistNodeId?: string) => {
    const wishlistNodeIdInput = 
        wishlistNodeId
            ? `wishlistNodeId:"${wishlistNodeId}"`
            : "";
    const query = 
    `
    mutation kqvDeleteAsinFromWishlist
    {
        deleteAsinFromWishlist(
            input : {
                ${wishlistNodeIdInput}
                asin:"${asin}"
            }
        ) {
            result
        }
    }
    `;
    return minifyGraphQLQuery(query);
}